// extracted by mini-css-extract-plugin
export default {"numberStatCell":"Row_numberStatCell__OLonm","textCell":"Row_textCell__5ICUu","previewCell":"Row_previewCell__I4aC1"};